(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pnl-signature-style"] && !Shopify.designMode) return;
  try {
    function pnlSignatureReveal(scope=document){
 if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){entry.target.classList.remove('pnl-s-waiting');entry.target.classList.add('pnl-s-shown');observer.unobserve(entry.target)}}},{threshold:0.04,rootMargin:'0px 0px 55px 0px'});
 for(const element of scope.querySelectorAll('.pnl-s-reveal:not([data-pnl-signature-reveal])')){element.dataset.pnlSignatureReveal='true';if(element.getBoundingClientRect().top>innerHeight)element.classList.add('pnl-s-waiting');observer.observe(element)}
}
pnlSignatureReveal();document.addEventListener('shopify:section:load',event=>pnlSignatureReveal(event.target));document.addEventListener('focusin',event=>event.target.closest('.pnl-s-waiting')?.classList.remove('pnl-s-waiting'));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnl-vip-purchase"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pnl-vip-purchase'))customElements.define('pnl-vip-purchase',class extends HTMLElement{
 static busy=false;
 connectedCallback(){if(this.bound)return;this.bound=true;this.querySelector('[data-vip-add]')?.addEventListener('click',()=>this.add())}
 async add(){
  if(this.dataset.ready!=='true'||this.constructor.busy||this.uncertain)return;
  const form=this.closest('form');const alone=this.dataset.standalone==='true';
  if(!alone&&(!form||!form.reportValidity()))return;
  const fields=form?new FormData(form):new FormData();
  const id=String(fields.get('id')||'');const quantity=Number(fields.get('quantity')||1);
  if(!alone&&(!/^\d+$/.test(id)||!Number.isInteger(quantity)||quantity<1))return;
  const button=this.querySelector('[data-vip-add]');const label=this.querySelector('[data-vip-button-label]');const original=label.textContent;const feedback=this.querySelector('[data-vip-feedback]');
  feedback.textContent='';this.constructor.busy=true;button.disabled=true;button.setAttribute('aria-busy','true');label.textContent=this.dataset.busy;
  let sent=false;
  try{
   const root=window.Shopify?.routes?.root||'/';const before=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});if(!before.ok)throw new Error();
   const cart=await before.json();const exists=cart.items.some(item=>String(item.variant_id)===this.dataset.membership);
   const request=new FormData();let index=0;
   if(!alone){request.append('items[0][id]',id);request.append('items[0][quantity]',String(quantity));for(const [key,value] of fields){const match=key.match(/^properties\[(.+)\]$/);if(match)request.append('items[0][properties]['+match[1]+']',value)}const plan=fields.get('selling_plan');if(plan)request.append('items[0][selling_plan]',plan);index=1;}
   if(!exists){request.append('items['+index+'][id]',this.dataset.membership);request.append('items['+index+'][quantity]','1');}
   if(alone&&exists){window.location.assign(this.dataset.cartUrl);return}
   sent=true;const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:request});const result=await response.json();
   if(!response.ok){throw new Error(result.description||result.message||'')}
   window.location.assign(this.dataset.cartUrl);
  }catch(error){this.uncertain=sent;feedback.textContent=this.dataset.error+(error.message?' '+error.message:'');this.querySelector('[data-vip-cart]').hidden=false;button.disabled=this.uncertain;label.textContent=original;
  }finally{this.constructor.busy=false;button.removeAttribute('aria-busy')}
 }
});
  } catch(e) { console.error(e); }
})();

})();
